import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { FETCH_BRANCH_SYNC_INFO } from 'src/redux/repo-commits/actions';
import authRequest from 'src/utils/fetch';

import { useBranchUrls } from '../urls';

export function useFetchBranchSyncInfo(
  sourceHash: string,
  destHash: string
): void {
  const { specBranchSyncInfoUrl } = useBranchUrls();
  const branchSyncInfoUrl = specBranchSyncInfoUrl(sourceHash, destHash);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!sourceHash || !destHash) {
      return;
    }
    (async function () {
      try {
        const branchSyncInfoResponse = await fetch(
          authRequest(branchSyncInfoUrl)
        );
        if (!branchSyncInfoResponse.ok) {
          const error = new Error(
            'Error fetching branch sync info on branch page'
          );
          // @ts-ignore
          error.status = branchSyncInfoResponse.status;
          throw error.message;
        }
        const info = await branchSyncInfoResponse.json();
        dispatch({
          type: FETCH_BRANCH_SYNC_INFO.SUCCESS,
          payload: info,
        });
      } catch {
        dispatch({
          type: FETCH_BRANCH_SYNC_INFO.ERROR,
        });
      }
    })();
  }, [dispatch, destHash, branchSyncInfoUrl, sourceHash]);
}
